import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PropsTable = makeShortcode("PropsTable");
const PropsTableRow = makeShortcode("PropsTableRow");
const InlineCode = makeShortcode("InlineCode");
const PropsTableBasePropRows = makeShortcode("PropsTableBasePropRows");
const PropsTableAsRow = makeShortcode("PropsTableAsRow");
const PropsTablePassthroughPropsRow = makeShortcode("PropsTablePassthroughPropsRow");
const Link = makeShortcode("Link");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {CircleBadge} from '@primer/react'
`}</code></pre>
    <p>{`Use CircleBadge to visually connect logos of third party services like in marketplace. Use CircleBadge.Icon to add an Octicon to the CircleBadge.`}</p>
    <h2>{`Examples`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<CircleBadge>
  <CircleBadge.Icon icon={ZapIcon} />
</CircleBadge>
`}</code></pre>
    <h2>{`Props`}</h2>
    <h3>{`CircleBadge`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="variant" type="'small' | 'medium' | 'large'" defaultValue="'medium'" description={<>
        Creates a smaller or larger badge. Has no effect if the <InlineCode mdxType="InlineCode">size</InlineCode> prop is set
      </>} mdxType="PropsTableRow" />
  <PropsTableRow name="size" type="number" description={<>
        Sets the size of the badge in pixels. Overrides the <InlineCode mdxType="InlineCode">variant</InlineCode> prop when set
      </>} mdxType="PropsTableRow" />
  <PropsTableRow name="inline" type="boolean" defaultValue="false" description={<>
        Styles the badge to <InlineCode mdxType="InlineCode">display: inline</InlineCode>
      </>} mdxType="PropsTableRow" />
  <PropsTableBasePropRows elementType="div" isPolymorphic refType="HTMLDivElement" mdxType="PropsTableBasePropRows" />
    </PropsTable>
    <h3>{`CircleBadge.Icon`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableAsRow defaultElementType="StyledOcticon" mdxType="PropsTableAsRow" />
  <PropsTablePassthroughPropsRow elementName="StyledOcticon" isPolymorphic passthroughPropsLink={<>
        the <Link href="/StyledOcticon" mdxType="Link">StyledOcticon docs</Link>
      </>} mdxType="PropsTablePassthroughPropsRow" />
    </PropsTable>
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: false,
      adaptsToScreenSizes: true,
      fullTestCoverage: false,
      usedInProduction: false,
      usageExamplesDocumented: true,
      hasStorybookStories: false,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      